import React, { Component } from 'react';

//generic functions
import {
    isEmpty
} from "../../../functions/generic_functions";


/*
    props:
        onChangeSetParentState => changes parent state function
        name => name of this component
        value => set the value of this component from the parent
        radioBtnOptions => array list of radio btn options to load with
        required => true/false if this field is required => if it is and it is empty, shows red colored radio btns
        disabled => true/false disables the radio btn
        className => className of the container of the radiobox
        divClassName => className of each individual container of the radiobox
        radioBtnClassName => classname of the radiobtns
*/

class RadioBtnHorizontal extends Component {
    constructor(props) {
        super(props);
       
        //action handlers
        this.handleOnChange = this.handleOnChange.bind(this);
    }

    handleOnChange(event) {
        var currVal = event.target.value;

        //set the value at the parent if the set function exists
        if (this.props.onChangeSetParentState) {
            this.props.onChangeSetParentState(currVal, this.props.name);
        }
    }

    render() { 

        return ( 
            <div className={(!isEmpty(this.props.className) ? this.props.className : "")}>
                {(!isEmpty(this.props.radioBtnOptions)) ?
                    this.props.radioBtnOptions.map(function (data, i) {
                        return (
                            <div
                                key={i}
                                className={"horizontal_radio_btn_format " + (!isEmpty(this.props.divClassName) ? this.props.divClassName : "")}
                            >
                                <label className="p-radiobutton-label pull_left">
                                    <input
                                        type='radio'
                                        name={(!isEmpty(this.props.name) ? this.props.name : "")}
                                        value={data.value}
                                        checked={!isEmpty(this.props.value) ? this.props.value.toLowerCase() === data.value.toLowerCase() : false}
                                        onChange={(e) => this.handleOnChange(e)}
                                        className={"p-radiobutton p-radiobutton-box p-radiobutton-icon p-c p-component " + (!isEmpty(this.props.radioBtnClassName) ? this.props.radioBtnClassName : "")}
                                        required={(!isEmpty(this.props.required) ? this.props.required : false)}
                                        disabled={(!isEmpty(this.props.disabled) ? this.props.disabled : false)}
                                    />
                                </label>
                                <span className="horizontal_radio_btn_text_padding">
                                    {data.label}
                                </span>
                            </div>
                        );
                    }.bind(this))
                : null}
            </div>    
        );
    }
}

export default RadioBtnHorizontal;
